// extracted by mini-css-extract-plugin
export default {"list":"InfoModal_list__csHw9"};